import { remove } from 'js-cookie';
const GA_COOKIE_NAMES = ['_ga', '_gid', '_gat'];
/**
 * Removes any google analytics cookies available to the app.
 */
export function removeGACookies() {
    for (const cookie of GA_COOKIE_NAMES) {
        remove(cookie);
    }
}
//# sourceMappingURL=google-analytics.js.map